export default __webpack_public_path__ + "68517a448567a6bbd61b7c7f21faedcc.png";